import { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { UserOutlined } from '@ant-design/icons'
import {
  Breadcrumb,
  Button,
  Card,
  Col,
  Collapse,
  Divider,
  Form,
  Icon,
  Modal,
  notification,
  Radio,
  Row,
  Switch,
  Table,
  Tabs,
  Tooltip,
  Typography
} from 'antd'
import { Formik } from 'formik'
import { get, merge, omit, pickBy } from 'lodash'
import { v4 as uuid_v4 } from 'uuid'

import { Creators as LoadingActions } from '../../appRedux/ducks/loading'
import ConfirmIco from '../../assets/images/ico_aprovado.svg'
import AlertIcon from '../../assets/images/ico_erro.svg'
import CustomInput from '../../components/CustomInput/customInput'
import CustomMap from '../../components/CustomMap/customMap'
import CustomSelect from '../../components/CustomSelect/customSelect'
import { TableLineDisable } from '../../components/TableLineDisable/TableLineDisable'
import { RULES, validRule } from '../../constants/Entitlements'
import injectValidationMethods from '../../util/checkValidation'
import { api, request } from '../../util/handlerRequestUtil'
import { getMessage } from '../../util/IntlMessages'
import { orderObjects } from '../../util/orderObjects'
import { isAdmin, isGR, isRtv } from '../../util/profiles'
import CustomerActionsPlan from './ActionPlan/CustomerActionsPlan'
import ListGroups from './AlternativeGroups/Groups.List'
import { listCustomerGroups } from './AlternativeGroups/listCustomerGroups'
import './CreateCustomer.css'
import Cultivars from './cultivars/Cultivars'
import CultivarsHistory from './cultivars/CultivarsHistory'
import { FormValidations } from './customerValidations'
import CreateForecasts from './forecasts/CreateForecasts'
import ListLocations from './ListLocations'
import Gallery from './pages/Gallery'
import Header from './pages/Header'
import Locals from './pages/Locals'
import Visits from './pages/Visits'

const { TabPane } = Tabs
const { Panel } = Collapse
const { confirm, error } = Modal

const CreateCustomer = function ({ match, history }) {
  const compState = {
    formatedRegions: [],
    formatedDistricts: []
  }

  const [formatedCities, setFormatedCities] = useState([])
  const [formatedStates, setFormatedStates] = useState([])
  const [formatedCustomerType, setFormatedCustomerType] = useState([])
  const [formatedLocations] = useState([])
  const [locationDistrictIds, setLocationDistrictIds] = useState([])
  const [mapLatitude, setMapLatitude] = useState(undefined)
  const [mapLongitude, setMapLongitude] = useState(undefined)
  const [mapZoom, setMapZoom] = useState(undefined)
  const [groups, setGroups] = useState([])
  const [currentGroupId, setCurrentGroupId] = useState('')
  const [sucessModalLabel] = useState('')
  const [alertError] = useState(false)
  const [state, setState] = useState(compState)
  const [topConsultantsForDropdown, setTopConsultantsForDropdown] = useState([])

  // Custom Fields
  const [selectedCustumerType, setSelectedCustumerType] = useState([])
  const [, setIsModalLocationVisible] = useState(false)
  const [isModalConfirmVisible, setIsModalConfirmVisible] = useState(false)
  const [contacts, setContacts] = useState([])
  const [collapsed, setCollapsed] = useState(false)
  const [memberDistricts, setMemberDistricts] = useState([])
  const [documentTypes, setdocumentTypes] = useState([])
  const auth = useSelector((reduxState) => reduxState.auth)
  const dispatch = useDispatch()

  // Params url
  const [id, setId] = useState(match.params.id)
  const actionRef = useRef(null)

  // Form configuration
  const [formValues, setFormValues] = useState({})
  const currentUser = useSelector((state) => state.auth.auth)

  const [contactForm, setContactForm] = useState({})
  const [errors, setErrors] = useState({})
  const [editingContactId, setEditingContactId] = useState(null)

  async function retrieveLocationDistrictIds(customerId) {
    const { regions: memberRegions, districts: memberDistricts } = currentUser

    let params = {
      active: true
    }
    if (isRtv()) {
      params.districtId = memberDistricts.map(({ id }) => id)
    } else if (isGR()) {
      params.regionId = memberRegions.map(({ id }) => id)
    }
    const items = await request(api.listCustomerLocations(customerId, { params }))
    const districtIds = (items || []).map(({ districtId }) => districtId)
    setLocationDistrictIds(districtIds)
  }

  function getValidation() {
    let dinamicValidations = {}
    return FormValidations([], dinamicValidations)
  }

  function handleHeadQuarter(headquarter) {
    return headquarter && headquarter === 'true'
  }

  const form = {
    initialValues: formValues,
    yupValidation: getValidation(),
    onSubmit: async (values) => {
      if (contacts.length === 0) {
        notification.error({
          description: getMessage('errorStoreCustomerWithoutContact'),
          message: getMessage('notification.error')
        })
      } else {
        const city = formatedCities.find((currentCity) => currentCity.value === values.city)
        let data = {
          active: get(values, 'active', true),
          addressComplement: get(values, 'addressComplement', ''),
          addressDescription: get(values, 'addressDescription', ''),
          addressNumber: get(values, 'addressNumber', ''),
          cityStateId: Number(get(city, 'id', null)) || null,
          documentNumber: get(values, 'documentNumber'),
          documentTypeId: get(values, 'documentTypeId'),
          headquarter: handleHeadQuarter(get(values, 'headquarter', false)),
          isEib: get(values, 'isEib', false),
          name: get(values, 'name'),
          neighborhood: get(values, 'neighborhood', ''),
          zipCode: get(values, 'zipCode', '')
        }

        if (contacts.length > 0) {
          contacts.map((contact) => {
            if (contact.isMain) {
              data.phoneNumber = contact.phoneNumber
              data.emailAddress = contact.email
            }
          })
          data.contacts = contacts
        }
        if (values['maps.long'] || values['maps.lat']) {
          data.coordinates = get(values, 'maps.lat', 0) + ',' + get(values, 'maps.long', 0)
        }
        if (selectedCustumerType.length > 0) {
          data.customerHasCustomerTypes = selectedCustumerType.map((costumerType) => ({
            id: costumerType.id,
            customerId: id,
            customerTypeId: costumerType
          }))
        }
        const selectedTopConsultantValues = get(values, 'topConsultants')
        data.customerHasTopConsultantTypes = selectedTopConsultantValues?.map((value) => ({
          customerId: id,
          topConsultantTypeId: value
        }))

        if (values.customers) {
          data.parentCustomerId = parseInt(values.customers)
        }
        if (!id) {
          storeCustomer(data)
        } else {
          const payload = { id, data: { ...data } }
          for (const key in payload.data) {
            // TODO: Verify if the following logic its actually necessary
            if (payload.data[key] === null && key !== 'cityStateId') {
              delete payload.data[key]
            }
          }
          updateCustomer(payload)
        }
      }
    }
  }

  // Mount/Umount component
  useEffect(() => {
    const hasAccess = validRule(RULES.CUSTOMER) // Não deixa acessar a tela
    if (!hasAccess) {
      return history.push('/home')
    }
    listStates()
    listCustomerType({ todos: false })
    getTopConsultantsTypes({ todos: false })

    if (id) {
      retrieveCustomer(id)
      listCustomerLocations(id)
      setFormValuesLocations({})
      listAlternativesGroups(id)
      getDistrictsByCustomer(id)
      setFormattedDataLocations({})
      listCustomerContacts(id)
      retrieveLocationDistrictIds(id)
    } else {
      setFormValues({
        'maps.lat': mapLatitude,
        'maps.long': mapLongitude,
        'maps.zoom': mapZoom
      })
      retrieveRegions()
    }
    listDocumentTypes()
  }, [])

  useEffect(() => {
    if (mapLatitude && mapLongitude && mapZoom) {
      setFormValues({
        ...formValues,
        'maps.lat': mapLatitude,
        'maps.long': mapLongitude,
        'maps.zoom': mapZoom
      })
    }
  }, [mapLatitude, mapLongitude, mapZoom])

  useEffect(() => {
    if (currentGroupId) {
      listCustomerAlternativeDocuments()
    } else {
      setFormatedDataAlternativeDocuments([])
    }
  }, [currentGroupId])

  // Api requests
  async function getDistrictsByCustomer(customerId) {
    const fetchDistricts = async (regions = null) => {
      const hasRegions = Boolean(regions)
      return hasRegions
        ? await request(api.getDistricts(customerId, regions))
        : await request(api.getDistricts(customerId))
    }

    /**
     * The user verification is supposed to be done on the backend.
     * This will be addressed in card #AD-9610.
     */
    const districts = await fetchDistricts(isAdmin() ? null : currentUser.regions)

    const filteredDistricts =
      !isAdmin() && isRtv()
        ? districts.filter((district) => (currentUser.districts || []).some(({ id }) => id === Number(district.value)))
        : districts

    setMemberDistricts(filteredDistricts)
  }

  async function storeCustomer(data) {
    try {
      const response = await request(api.storeCustomer(data))
      if (response) {
        notification.success({
          description: getMessage('successStoreCustomer'),
          message: getMessage('sweetAlerts.success')
        })
        if (actionRef.current === 'save') {
          window.location.href = `/customer/list`
        } else if (actionRef.current === 'nextTab') {
          setId(response.id)
          setActiveKey((activeKey + 1) % 8)

          if (activeKey === 4 && (isAdmin() || isRtv())) {
            setActiveKey(8)
          }
        }
        window.location.href = `/customer/${response.id}`
      } else {
        history.goBack()
      }
    } catch (error_) {
      console.tron.log(error_)
    }
  }

  async function retrieveCustomer(id) {
    try {
      const response = await request(api.retrieveCustomer(id))
      const formatedTypes = []
      if (response.customerLocations) {
        response.customerLocations.map((item) => {
          if (item !== null && item.location !== null) {
            return formatedLocations.push(item.location.id)
          }
        })
      }
      const formattedCoords = response.coordinates ? response.coordinates : { x: mapLatitude, y: mapLongitude }
      setTimeout(() => setMapLatitude(formattedCoords.x), 1000)
      setTimeout(() => setMapLongitude(formattedCoords.y), 1000)
      const selectedCustomTypeLoaded = []
      if (response.customerHasCustomerTypes) {
        response.customerHasCustomerTypes.map(async (item) => {
          formatedTypes.push(item.customerTypeId)
          selectedCustomTypeLoaded.push(item.customerTypeId)
        })
        setSelectedCustumerType(selectedCustomTypeLoaded)
      }
      const formatedCustomFields = {}
      if (response.customFields) {
        response.customFields.map((item) => {
          const normlizedItem = pickBy(item, null)
          return merge(formatedCustomFields, omit(normlizedItem, ['created_at', 'updated_at', 'id', 'form_id']))
        })
      }
      let cordenate = {}
      if (response.coordinates !== null) {
        cordenate = {
          'maps.lat': response.coordinates.x || '',
          'maps.long': response.coordinates.y || ''
        }
      }

      const customerHasTopConsultantTypes = []
      if (response.customerHasTopConsultantTypes.length) {
        response.customerHasTopConsultantTypes.forEach((type) =>
          customerHasTopConsultantTypes.push(type.topConsultantTypeId)
        )
      }
      const cityState = get(response, 'cityState')
      const newFormValues = {
        ...response,
        ...formatedCustomFields,
        customFields: formatedCustomFields,
        state: get(cityState, 'stateAbbreviation'),
        city: get(cityState, 'name'),
        types: formatedTypes,
        locations: formatedLocations,
        topConsultants: customerHasTopConsultantTypes,
        ...cordenate
      }

      if (isRtv()) {
        const districtObj = get(auth, 'auth.parentMember.district', null)
        if (districtObj) {
          newFormValues.region = get(districtObj, 'regionId')
          newFormValues.district = districtObj.id
        }
      }
      setFormValues(newFormValues)
      const newFormatedCities = [
        {
          value: get(cityState, 'id'),
          description: get(cityState, 'name')
        }
      ]
      setFormatedCities(newFormatedCities)
    } catch (error_) {
      console.tron.log(error_)
    }
  }

  async function listCustomerContacts(customerId) {
    try {
      const response = await request(api.listContacts({ customerId: customerId }))
      setContacts(
        response.map((c) => ({
          ...c,
          uuid: c.id
        }))
      )
    } catch (error_) {
      console.log(error_)
    }
  }

  async function updateCustomer(payload) {
    try {
      const { id, data } = payload
      await request(api.updateCustomer(id, data))
      notification.success({
        description: getMessage('successUpdateCustomer'),
        message: getMessage('sweetAlerts.success')
      })
      if (actionRef.current === 'save') {
        window.location.href = `/customer/list`
      } else if (actionRef.current === 'nextTab') {
        setId(id)
        setActiveKey((activeKey + 1) % 8)

        if (activeKey === 3 && isAdmin()) {
          setActiveKey(7)
        }

        if (activeKey === 3 && isGR()) {
          setActiveKey(0)
        }

        if (activeKey === 7 && isRtv()) {
          setActiveKey(0)
        }
      }
    } catch (error_) {
      console.tron.log(error_)
    }
  }

  async function deleteLocation(localId) {
    try {
      await request(api.destroyLocation(localId), false, true).catch(({ data }) => {
        showAlertMessage(data.message, data.description)
      })
      listCustomerLocations(id)
      retrieveLocationDistrictIds(id)
    } catch (error_) {
      console.tron.log(error_)
    }
  }

  function showAlertMessage(title, message) {
    error({
      title,
      icon: null,
      content: (
        <span style={{ marginLeft: !message ? 90 : 0 }}>
          {!message ? getMessage('SureToDelete?') : getMessage(message)}
        </span>
      ),
      cancelButtonProps: {
        style: {
          width: 148,
          borderColor: '#EE778F',
          color: '#EE778F'
        },
        type: 'ghost'
      },
      okButtonProps: {
        className: 'button-action',
        type: 'primary',
        style: {
          marginRight: -40
        }
      },
      okText: getMessage('label.ok')
    })
  }

  function showConfirm(onDeleteFunc, message) {
    confirm({
      title: <img src={AlertIcon} alt="" style={{ marginLeft: '42%' }} />,
      icon: null,
      content: (
        <span style={{ marginLeft: !message ? 90 : 0 }}>
          {!message ? getMessage('SureToDelete?') : getMessage(message)}
        </span>
      ),
      cancelButtonProps: {
        style: {
          width: 148,
          borderColor: '#EE778F',
          color: '#EE778F'
        },
        type: 'ghost'
      },
      okButtonProps: {
        className: 'button-action',
        type: 'primary',
        style: {
          marginRight: 10
        }
      },
      okText: getMessage('label.yes'),
      cancelText: getMessage('label.no'),
      onOk() {
        if (onDeleteFunc) {
          onDeleteFunc()
        }
      },
      onCancel() {
        console.log('cancelou')
      }
    })
  }

  async function listCitiesByState(params) {
    try {
      const response = await request(api.listCitiesByState(params))
      const formatedData = []
      response.map((item) => {
        return formatedData.push({
          value: item.cityCode,
          id: item.id,
          description: item.name
        })
      })
      formatedData.sort(orderObjects('description'))
      setFormatedCities(formatedData)
    } catch (error_) {
      console.tron.log(error_)
    }
  }

  async function listCustomerType(param) {
    try {
      param.todos = false
      const response = await request(api.listCustomerTypesDropdown(param), true)
      setFormatedCustomerType(response)
    } catch (error_) {
      console.tron.log(error_)
    }
  }

  async function getTopConsultantsTypes(param) {
    try {
      const response = await request(api.getTopConsultantsForDropdown(param), true)
      setTopConsultantsForDropdown(response)
    } catch (error_) {
      console.tron.log(error_)
    }
  }

  async function listStates() {
    try {
      const response = await request(api.listStatesDropdown(), true)
      const formatedData = []
      response.map((item) => {
        return formatedData.push({
          value: item.stateAbbreviation,
          description: `${item.stateName} - ${item.stateAbbreviation}`
        })
      })
      formatedData.sort(orderObjects('description'))
      setFormatedStates(formatedData)
    } catch (error_) {
      console.tron.log(error_)
    }
  }

  async function retrieveRegions() {
    request(api.getRegionsDropdown(), true).then((formatedRegions) => {
      let formatedDistricts = []
      if (isRtv()) {
        const district = get(auth, 'auth.parentMember.district', null)
        if (district) {
          formatedDistricts = [
            {
              value: district.id,
              description: district.districtName
            }
          ]
          if (!id) {
            setFormValues({
              region: get(district, 'regionId'),
              district: district.id
            })
          }
        }
      }

      const currentState = {
        ...state,
        formatedRegions,
        formatedDistricts
      }
      setState(currentState)
      return currentState
    })
  }

  async function listDocumentTypes() {
    await request(api.listDocumentTypes(), true).then((types) => {
      const formatedData = []
      types.map((item) => {
        return formatedData.push({
          value: item.id,
          description: item.name,
          mask: item.mask
        })
      })
      setdocumentTypes(formatedData)
    })
  }

  async function getCepData(cep, currentFormValues) {
    try {
      const response = await request(api.getCepData(cep))

      const newFormValues = {
        ...currentFormValues,
        addressDescription: response.logradouro || formValues.addressDescription,
        addressComplement: response.complemento || formValues.addressComplement,
        neighborhood: response.bairro || formValues.neighborhood,
        state: response.uf || formValues.state,
        city: Number(get(response, 'ibge')),
        ZipCode: cep
      }
      return newFormValues
    } catch (error_) {
      console.tron.log(error_)
    }
  }

  async function getCoordinates(fullAddress) {
    const query = encodeURIComponent(fullAddress)
    const coordinatesResponse = await request(api.getCoordinatesFromCep(query))

    if (coordinatesResponse.length && coordinatesResponse[0].lat && coordinatesResponse[0].lon) {
      return {
        latitude: coordinatesResponse[0].lat,
        longitude: coordinatesResponse[0].lon
      }
    }
    return null
  }

  async function fillFormCoordinatesFromCep(fullAddress) {
    const coordinates = await getCoordinates(fullAddress)
    if (!coordinates) return

    setMapLatitude(coordinates.latitude)
    setMapLongitude(coordinates.longitude)
    return coordinates
  }

  async function onChangeZipCode(_, eventValue) {
    const formatedValue = eventValue.replace(/_/g, '')
    if (formatedValue.length === 9) {
      const newFormatedData = {
        ...formValues,
        zipCode: formatedValue,
        state: getMessage('loading...'),
        city: getMessage('loading...')
      }
      setFormValues(newFormatedData)
      dispatch(LoadingActions.openLoading())
      const cepDataCurrentFormValues = await getCepData(formatedValue, newFormatedData)

      const fullAddress = [
        cepDataCurrentFormValues.addressDescription,
        cepDataCurrentFormValues.city,
        cepDataCurrentFormValues.state
      ]
        .filter(Boolean)
        .join(', ')

      const coordinates = await fillFormCoordinatesFromCep(fullAddress)

      await listCitiesByState({
        stateAbbreviation: cepDataCurrentFormValues.state
      })

      setFormValues({
        ...cepDataCurrentFormValues,
        'maps.lat': coordinates ? coordinates.latitude : undefined,
        'maps.long': coordinates ? coordinates.longitude : undefined
      })
    }

    dispatch(LoadingActions.closeLoading())
  }

  async function onChangeState(value) {
    if (formValues.state !== value) {
      const newFormatedData = {
        ...formValues,
        state: value,
        city: getMessage('select')
      }

      await listCitiesByState({
        stateAbbreviation: value.toString()
      })
      setFormValues(newFormatedData)
    }
  }

  // LIST LOCATIONS
  const [, setFormValuesLocations] = useState({})
  const [, setFormattedDataLocations] = useState({})

  async function listCustomerLocations(id, params) {
    if (!id) {
      return
    }

    try {
      const newParams = {
        ...params,
        include: 'cityState,region',
        filterDistrictWallet: false
      }

      const response = await request(api.listCustomerLocations(id, newParams), true)
      const itens = get(response, 'items')

      const formatedRows = itens
        .filter((item) => item.location !== null)
        .map((item) => {
          const mainContact = get(item.location, 'contacts', []).find((contact) => contact.isMain)
          const phoneNumber = mainContact ? mainContact.phoneNumber : '-'
          const regionId = get(item.region, 'id')
          const districtId = get(item.district, 'id')
          const enableActions = loggedUserCanEditRegionAndDistrict(regionId, districtId)

          return {
            key: get(item.location, 'id'),
            active: get(item.location, 'active'),
            isEib: get(item.location, 'isEib'),
            customerLocationName: get(item.location, 'locationName'),
            customerLocationDocument: get(item.location, 'documentNumber', '-'),
            customerLocationContact: phoneNumber,
            customerLocationAddress: mountAddressLocations(item.location),
            customerLocationRegion: get(item.region, 'regionName', '-'),
            customerLocationDistrict: get(item.district, 'districtName', '-'),
            customerLocationCity: item.cityState
              ? `${item.cityState.cityName}/${item.cityState.stateAbbreviation}`
              : '-',
            actions: formatActionsLocations(id, item.location.id, enableActions),
            ...item
          }
        })
      setIsModalLocationVisible(false)
      setFormattedDataLocations({
        items: formatedRows,
        pageSizeLocations: get(response, 'pageSize'),
        pageLocations: get(response, 'page'),
        countLocations: get(response, 'count')
      })
    } catch (error_) {
      console.tron.log(error_)
    }
  }

  function loggedUserCanEditRegionAndDistrict(region, district) {
    const { memberRegionId, memberDistrictId } = currentUser
    if (isAdmin() || !region || !district) return true
    if (isGR() && +region === +memberRegionId) return true
    return +region === +memberRegionId && +district === +memberDistrictId
  }

  // LIST Alternativ
  const [formatedDataAlternativeDocuments, setFormatedDataAlternativeDocuments] = useState([])

  async function listAlternativesGroups(id) {
    try {
      const groups = await listCustomerGroups(id, true)
      setGroups(groups)
    } catch (error_) {
      console.tron.log(error_)
    }
  }

  async function listCustomerAlternativeDocuments() {
    try {
      if (!currentGroupId) {
        return false
      }
      const response = await request(api.findAlternativesByGroupId(currentGroupId), false, true)
      const formattedRows = []

      if (response) {
        for (const document of response) {
          let formattedDocument = {
            key: get(document, 'id'),
            partnerName: get(document, 'partnerName'),
            approval: formatStatusAlternativeDocuments(document.approvalStatus),
            ...document
          }
          if (document.original) {
            formattedRows.unshift(formattedDocument)
          } else {
            formattedRows.push(formattedDocument)
          }
        }
      }
      setFormatedDataAlternativeDocuments(formattedRows)
      return formattedRows
    } catch (error_) {
      console.tron.log(error_)
    }
  }

  const COLUMN_LOCATION_RENDER = (item, line) => <TableLineDisable item={item} line={line} />

  function mountAddressLocations(location) {
    const { addressDescription, addressNumber, zipCode } = location
    let address = addressDescription

    if (addressNumber) {
      address += `, ${addressNumber}`
    }

    if (zipCode) {
      address += ` - ${zipCode}`
    }

    return `${address}.`
  }

  function formatActionsLocations(id, idLocation, enableActions = false) {
    return (
      <div style={{ display: 'flex', marginLeft: -35 }}>
        <Button
          className="location-button"
          type="link"
          disabled={!enableActions}
          onClick={() => {
            setIsModalLocationVisible(true)
          }}
        >
          <Icon type="edit" className="location-icon" />
        </Button>
        <Button
          className="location-button"
          type="link"
          disabled={!enableActions}
          onClick={() => {
            showConfirm(() => {
              deleteLocation(idLocation)
            })
          }}
        >
          <Icon type="delete" className="location-icon" />
        </Button>
      </div>
    )
  }

  const formatStatusAlternativeDocuments = (approvalStatus) => (
    <div style={{ display: 'flex' }}>
      <div
        style={{
          width: 10,
          height: 10,
          marginRight: 5,
          borderRadius: 50,
          backgroundColor: approvalStatus === 'Aguardando aprovação' ? '#FFB40B' : '#22C787'
        }}
      ></div>
      {approvalStatus === 'Aguardando aprovação' ? 'Aguardando aprovação' : 'Aprovado'}
    </div>
  )

  function renderButtons(submitForm) {
    const hasAccess = id === null ? validRule(RULES.CUSTOMER) : validRule(RULES.CUSTOMER)
    return (
      <div className="header-buttons">
        <Button className="button button-return" onClick={() => history.goBack()}>
          <Icon type="left" theme="outlined" className="button-icon" />
          {getMessage('back')}
        </Button>
        {activeKey < 3 && hasAccess && (
          <Button className="button button-action" type="primary" onClick={() => submitForm()}>
            {id ? getMessage('update') : getMessage('register')}
          </Button>
        )}
      </div>
    )
  }

  function renderHeader(submitForm) {
    return (
      <div className="default-header-div">
        <div className="default-header-breadcrumb">
          {/* <CustomBreadcrumb match={match} history={history} /> */}
          <Breadcrumb>
            <Breadcrumb.Item onClick={() => history.push('/')}>
              <Icon
                type="home"
                theme="filled"
                style={{ fontSize: '16px', color: '#263447' }}
                onClick={() => history.push('/')}
              />
            </Breadcrumb.Item>
            <Breadcrumb.Item onClick={() => history.push('/customer/list')}>Agricultores</Breadcrumb.Item>
            <Breadcrumb.Item>{`${
              match.params.id ? 'Atualizar dados do agricultor' : 'Cadastrar agricultor'
            }`}</Breadcrumb.Item>
          </Breadcrumb>
          {renderButtons(submitForm)}
        </div>
      </div>
    )
  }

  function renderGpsMaping(values, errors, handleBlur, setFieldValueWithState) {
    return (
      <Panel header={getMessage('customer.label.maping')} key="5" className="site-collapse-custom-panel">
        <Card bordered={1} bodyStyle={{ paddingLeft: 0, paddingRight: 0 }}>
          <Row type="flex" justify="start">
            <Col span={24}>
              <Row type="flex" justify="start">
                <CustomMap
                  latitude={mapLatitude}
                  longitude={mapLongitude}
                  zoom={8}
                  setMapLatitude={setMapLatitude}
                  setMapLongitude={setMapLongitude}
                  setMapZoom={setMapZoom}
                />
              </Row>
            </Col>
          </Row>
          <Row type="flex" justify="start" style={{ marginTop: 20 }}>
            <CustomInput
              field="maps.lat"
              errors={errors}
              setFieldValue={setFieldValueWithState}
              rowSpan={6}
              value={values}
              handleBlur={(e) => {
                const v = e.target.value.replace(/[a-zA-Z]+/g, '')
                setMapLatitude(v)
                handleBlur(e)
              }}
            />
            <CustomInput
              field="maps.long"
              errors={errors}
              setFieldValue={setFieldValueWithState}
              rowSpan={6}
              value={values}
              handleBlur={(e) => {
                const v = e.target.value.replace(/[a-zA-Z]+/g, '')
                setMapLongitude(v)
                handleBlur(e)
              }}
            />
          </Row>
        </Card>
      </Panel>
    )
  }

  function isDisabledEdit() {
    return !isAdmin() && id
  }

  function renderGeneralData(values, documentTypeMask, errors, handleBlur, setFieldValueWithState) {
    return (
      <Panel header={getMessage('customer.title.info')} key="1" className="site-collapse-custom-panel">
        <Card bordered={1} bodyStyle={{ paddingLeft: 0, paddingRight: 0 }}>
          <div style={{ position: 'absolute', right: 10, top: 10, paddingBottom: 10 }}>
            <span style={{ marginRight: 10 }}>Agricultor ativo</span>
            <Switch
              size="small"
              checked={get(values, 'active', true)}
              onChange={(value) => {
                setFieldValueWithState('active', value)
              }}
            />
          </div>
          <div style={{ position: 'absolute', right: 10, top: 40, paddingBottom: 10 }}>
            <span style={{ marginRight: 10 }}>Participante EIB</span>
            <Switch
              size="small"
              checked={get(values, 'isEib', false)}
              onChange={(value) => {
                setFieldValueWithState('isEib', value)
              }}
            />
          </div>
          <Row type="flex" justify="start" style={{ padding: -16, marginTop: 10 }}>
            <CustomInput
              field="name"
              errors={errors}
              setFieldValue={setFieldValueWithState}
              rowSpan={6}
              required
              value={values}
              disabled={isDisabledEdit()}
              handleBlur={handleBlur}
            />
            <CustomSelect
              showSearch
              field="documentTypeId"
              errors={errors}
              setFieldValue={setFieldValueWithState}
              rowSpan={6}
              required
              value={values}
              values={documentTypes}
              enable={isDisabledEdit()}
              handleBlur={handleBlur}
            />
            <CustomInput
              field="documentNumber"
              errors={errors}
              setFieldValue={setFieldValueWithState}
              required
              rowSpan={6}
              value={values}
              disabled={isDisabledEdit()}
              handleBlur={handleBlur}
              mask={documentTypeMask}
            />
          </Row>
        </Card>
      </Panel>
    )
  }

  function renderAddress(values, errors, handleBlur, setFieldValueWithState) {
    return (
      <Panel header={getMessage('customer.title.address')} key="3" className="site-collapse-custom-panel">
        <Card bordered={1} bodyStyle={{ paddingLeft: 0, paddingRight: 0 }}>
          <Row type="flex" justify="start">
            <CustomInput
              field="zipCode"
              errors={errors}
              setFieldValue={setFieldValueWithState}
              rowSpan={6}
              value={values}
              onChangeWithField={onChangeZipCode}
              handleBlur={handleBlur}
              mask="11111-111"
            />
            <CustomSelect
              showSearch
              field="state"
              errors={errors}
              setFieldValue={setFieldValueWithState}
              rowSpan={6}
              value={values}
              onChange={onChangeState}
              values={formatedStates}
            />

            <CustomSelect
              showSearch
              field="city"
              errors={errors}
              setFieldValue={setFieldValueWithState}
              rowSpan={6}
              value={values}
              values={formatedCities}
            />
            <CustomInput
              field="addressDescription"
              errors={errors}
              setFieldValue={setFieldValueWithState}
              rowSpan={6}
              value={values}
              handleBlur={handleBlur}
            />
            <CustomInput
              field="addressNumber"
              errors={errors}
              setFieldValue={setFieldValueWithState}
              rowSpan={6}
              value={values}
              handleBlur={handleBlur}
            />
            <CustomInput
              field="neighborhood"
              errors={errors}
              setFieldValue={setFieldValueWithState}
              rowSpan={6}
              value={values}
              handleBlur={handleBlur}
            />
            <CustomInput
              field="addressComplement"
              errors={errors}
              setFieldValue={setFieldValueWithState}
              rowSpan={6}
              value={values}
              handleBlur={handleBlur}
            />
          </Row>
        </Card>
      </Panel>
    )
  }

  function renderContact(handleBlur) {
    const setValue = (field, value) => {
      setContactForm({ ...contactForm, [field]: value })
    }

    const setContactValue = (contactId, field, value) => {
      setContacts((currentContacts) =>
        currentContacts.map((contact) => (contact.uuid === contactId ? { ...contact, [field]: value } : contact))
      )
    }

    const validateContact = (currentContact = contactForm) => {
      let isValid = true
      const _errors = {}

      if (!currentContact.name) {
        isValid = false
        _errors.name = 'Campo nome do contato é obrigatório'
      }

      if (!isValid) {
        setErrors(_errors)
      }

      return isValid
    }

    const addContact = () => {
      if (validateContact()) {
        const newContact = { ...contactForm, uuid: uuid_v4(), isMain: contacts.length === 0 }
        setContacts([...contacts, newContact])
        setContactForm({})
      }
    }

    const removeContact = (uuid) => {
      const list = contacts.filter((c) => c.uuid !== uuid)
      setContacts(list)
    }

    const setIsMain = (uuid) => {
      const list = contacts.map((c) => ({
        ...c,
        isMain: c.uuid === uuid
      }))
      setContacts(list)
    }

    const startEditing = (contactId) => {
      setEditingContactId(contactId)
      setErrors({})
    }

    const saveEditedContact = async (contact) => {
      if (!contact.name) {
        setErrors({ name: 'Campo nome do contato é obrigatório' })
        return
      }

      try {
        const payload = omit(contact, ['uuid'])
        await request(api.updateContacts(contact.id, payload))
        notification.success({
          description: getMessage('successUpdateContacts'),
          message: getMessage('sweetAlerts.success')
        })
        setEditingContactId(null)
        setErrors({})
      } catch (err) {
        notification.error({
          description: getMessage('errorUpdateContacts'),
          message: getMessage('notification.error')
        })
      }
    }

    return (
      <Panel header={getMessage('customer.title.contact')} key="2" className="site-collapse-custom-panel">
        <Card bordered={1} bodyStyle={{ paddingLeft: 0, paddingRight: 0 }}>
          <Row type="flex" style={{ alignItems: 'center' }}>
            <CustomInput
              field="name"
              errors={editingContactId ? {} : errors}
              required
              setFieldValue={setValue}
              rowSpan={5}
              value={contactForm}
              handleBlur={handleBlur}
            />
            <CustomInput
              field="phoneNumber"
              errors={errors}
              setFieldValue={setValue}
              rowSpan={5}
              value={contactForm}
              handleBlur={handleBlur}
              mask={'(11)11111-1111'}
            />
            <CustomInput
              field="email"
              errors={errors}
              setFieldValue={setValue}
              rowSpan={5}
              value={contactForm}
              handleBlur={handleBlur}
            />
            <CustomInput
              field="jobRole"
              errors={errors}
              setFieldValue={setValue}
              rowSpan={5}
              value={contactForm}
              handleBlur={handleBlur}
            />
            <Button type="dashed" style={{ gap: '5px', color: 'white' }} onClick={addContact}>
              <Icon type="plus" size="small" style={{ color: '#fff', fontSize: 12 }} />
              <span style={{ fontWeight: '500', fontSize: '12px' }}> {getMessage('addContact')}</span>
            </Button>
          </Row>

          {contacts.map((contact, index) => {
            const isEditingContact = editingContactId === contact.uuid

            return (
              <Row key={`${contact.uuid || index}-${index}`} type="flex" style={{ alignItems: 'center' }}>
                <CustomInput
                  field="name"
                  errors={isEditingContact ? errors : {}}
                  required
                  setFieldValue={(field, value) => setContactValue(contact.uuid, field, value)}
                  rowSpan={5}
                  value={contact}
                  handleBlur={handleBlur}
                  disabled={!isEditingContact}
                />
                <CustomInput
                  field="phoneNumber"
                  setFieldValue={(field, value) => setContactValue(contact.uuid, field, value)}
                  rowSpan={5}
                  value={contact}
                  handleBlur={handleBlur}
                  mask={'(11)11111-1111'}
                  disabled={!isEditingContact}
                />
                <CustomInput
                  field="email"
                  setFieldValue={(field, value) => setContactValue(contact.uuid, field, value)}
                  rowSpan={5}
                  value={contact}
                  handleBlur={handleBlur}
                  disabled={!isEditingContact}
                />
                <CustomInput
                  field="jobRole"
                  setFieldValue={(field, value) => setContactValue(contact.uuid, field, value)}
                  rowSpan={5}
                  value={contact}
                  handleBlur={handleBlur}
                  disabled={!isEditingContact}
                />
                <Radio checked={contact.isMain} onClick={() => setIsMain(contact.uuid)}>
                  Principal
                </Radio>
                <Tooltip title={isEditingContact ? 'Salvar' : 'Editar contato'}>
                  <Button
                    type={isEditingContact ? 'primary' : 'ghost'}
                    onClick={() => {
                      if (isEditingContact) {
                        saveEditedContact(contact)
                        return
                      }
                      startEditing(contact.uuid)
                    }}
                  >
                    <Icon type={isEditingContact ? 'check' : 'edit'} size="small" />
                  </Button>
                </Tooltip>
                <Tooltip title="Deletar contato">
                  <Button type="ghost" onClick={() => showConfirm(() => removeContact(contact.uuid))}>
                    <Icon type="delete" size="small" />
                  </Button>
                </Tooltip>
              </Row>
            )
          })}
        </Card>
      </Panel>
    )
  }

  function renderCustom(values, errors, handleBlur, setFieldValueWithState) {
    return (
      <Panel header={getMessage('customer.title.specificfield')} key="4" className="site-collapse-custom-panel">
        <Card bordered={1} bodyStyle={{ paddingLeft: 0, paddingRight: 0 }}>
          <Row type="flex" justify="start">
            <CustomSelect
              field="types"
              errors={errors}
              setFieldValue={setFieldValueWithState}
              rowSpan={6}
              required
              value={values}
              values={formatedCustomerType}
              showSearch
              multiple
            />

            <CustomSelect
              field="topConsultants"
              label="Consultoria Líderes da Soja"
              errors={errors}
              setFieldValue={setFieldValueWithState}
              rowSpan={6}
              value={values}
              values={topConsultantsForDropdown}
              showSearch
              multiple
            />
          </Row>
        </Card>
      </Panel>
    )
  }

  const toggleCollapsed = () => setCollapsed((val) => !val)

  const getIconType = collapsed ? 'up' : 'down'

  function renderTabVision(values) {
    return (
      <TabPane tab="Visão 360" key="0">
        {values.id ? (
          <div>
            <Header customer={values} contact={contacts[0]} groups={groups} />

            <Divider />

            <Locals customer={values} />

            <Divider />

            <div style={{ padding: '2%' }}>
              <div className="default-header-div">
                <div className="default-header-breadcrumb">
                  <Typography.Title className="default-header-title" level={3}>
                    <Icon type={getIconType} style={{ marginRight: 13, fontSize: 15 }} onClick={toggleCollapsed} />
                    <UserOutlined style={{ marginRight: 13 }} />
                    {getMessage('customer.tab.alternatives')}
                  </Typography.Title>
                </div>

                {collapsed ? (
                  groups.length === 0 ? (
                    <div style={{ display: 'flex', flexDirection: 'column', margin: '10%' }}>
                      <UserOutlined style={{ fontSize: 50, color: '#8591A1' }} />
                      <Typography
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          fontWeight: 'bold',
                          color: '#8591A1',
                          padding: '10px 0px 10px'
                        }}
                        className="default-header-title"
                        level={3}
                      >
                        {getMessage('emptyGroupAlternative')}
                      </Typography>
                    </div>
                  ) : (
                    <>
                      {groups.map((group, index) => (
                        <>
                          <div className="group-row" key={index}>
                            <Typography
                              className="default-header-title"
                              style={{ color: '#334863', padding: '10px 0px 10px' }}
                              level={2}
                            >
                              <Icon
                                type={currentGroupId === group.id ? 'up' : 'down'}
                                style={{ marginTop: 10, marginRight: 13, fontSize: 15 }}
                                onClick={() => {
                                  if (currentGroupId === group.id) {
                                    setCurrentGroupId('')
                                  } else {
                                    setCurrentGroupId(group.id)
                                  }
                                }}
                              />
                              {group.description}
                            </Typography>
                          </div>
                          {currentGroupId === group.id && formatedDataAlternativeDocuments.length > 0 && (
                            <Table
                              columns={[
                                {
                                  title: getMessage('alternateName'),
                                  dataIndex: 'partnerName',
                                  width: 1,
                                  render: COLUMN_LOCATION_RENDER
                                },
                                {
                                  title: getMessage('alternateStatus'),
                                  dataIndex: 'approval',
                                  width: 1,
                                  render: COLUMN_LOCATION_RENDER
                                }
                              ]}
                              dataSource={formatedDataAlternativeDocuments}
                              pagination={false}
                            />
                          )}
                        </>
                      ))}
                    </>
                  )
                ) : null}
              </div>
            </div>

            <Divider />

            <Visits customer={values} />

            <Divider />

            <Gallery customer={values} />
          </div>
        ) : null}
      </TabPane>
    )
  }

  function renderTabGeneralData(values, documentTypeMask, errors, handleBlur, setFieldValueWithState) {
    return (
      <TabPane tab={getMessage('customer.tab.infotitle')} key="1" className="site-collapse-custom-panel">
        <Collapse
          bordered={false}
          defaultActiveKey={['1', '2', '3', '4', '5']}
          expandIcon={({ isActive }) => <Icon type="down" rotate={isActive ? 180 : 0} />}
          className="site-collapse-custom-collapse"
        >
          {renderGeneralData(values, documentTypeMask, errors, handleBlur, setFieldValueWithState)}
          {renderCustom(values, errors, handleBlur, setFieldValueWithState)}
          {renderContact(handleBlur)}
          {renderAddress(values, errors, handleBlur, setFieldValueWithState)}
          {renderGpsMaping(values, errors, handleBlur, setFieldValueWithState)}
        </Collapse>
      </TabPane>
    )
  }

  function renderTabLocations(id) {
    return (
      <TabPane tab={getMessage('customer.tab.locations')} key="2" disabled={!id} className="site-collapse-custom-panel">
        <div style={{ padding: '2%' }}>
          <ListLocations customerId={id} />
        </div>
      </TabPane>
    )
  }

  function renderTabAlternatives(id) {
    return (
      <TabPane
        tab={getMessage('customer.tab.alternatives')}
        key="3"
        disabled={!id}
        className="site-collapse-custom-panel"
      >
        <div style={{ padding: '2%' }}>
          <ListGroups customerId={id} groups={groups} setGroups={setGroups} />
        </div>
      </TabPane>
    )
  }

  const selectDistricts = memberDistricts.filter(({ value }) => locationDistrictIds.includes(value))

  function renderTabForecasts(id) {
    return (
      <TabPane tab={getMessage('customer.tab.forecast')} key="4" disabled={!id} className="site-collapse-custom-panel">
        {selectDistricts.length > 0 ? (
          <CreateForecasts customerId={id} districts={selectDistricts} />
        ) : (
          <h1 style={{ fontWeight: 'bold', fontSize: '30px', marginTop: '60px', marginLeft: '20px' }}>
            Não existem locais associados a sua Regional / Distrito para o Agricultor selecionado
          </h1>
        )}
      </TabPane>
    )
  }

  function renderTabCultivars(customerId) {
    return (
      <TabPane tab={getMessage('customer.tab.cultivars')} key="5" disabled={!id} className="site-collapse-custom-panel">
        <Cultivars currentUser={auth.auth} customerId={customerId} districts={selectDistricts} />
      </TabPane>
    )
  }

  function renderTabCultivarsHistory(customerId) {
    return (
      <TabPane
        tab={getMessage('customer.tab.cultivars.history')}
        key="6"
        disabled={!id}
        className="site-collapse-custom-panel"
      >
        <CultivarsHistory currentUser={auth.auth} customerId={customerId} districts={selectDistricts} />
      </TabPane>
    )
  }

  function renderTabActionPlan(id) {
    return (
      <TabPane
        tab={getMessage('customer.tab.actionPlan')}
        key="7"
        disabled={!id}
        className="site-collapse-custom-panel"
      >
        <div style={{ padding: '2%' }}>
          {(memberDistricts.length > 0 || isAdmin()) && <CustomerActionsPlan customerId={id} />}
          {memberDistricts.length === 0 && !isAdmin() && (
            <h1 style={{ fontWeight: 'bold', fontSize: '30px', marginTop: '60px', marginLeft: '20px' }}>
              Não existem locais associados a sua Regional / Distrito para o Agricultor selecionado
            </h1>
          )}
        </div>
      </TabPane>
    )
  }

  function getDocumentMask(documentId) {
    const documentType = documentTypes.find((item) => item.value === documentId)
    if (documentType) {
      return documentType['mask']
    }
    return null
  }

  function onChange(setFieldValue) {
    const setFieldValueWithState = (field, key) => {
      if (field === 'types') {
        setSelectedCustumerType(key)
      }
      setFormValues({ ...formValues, [field]: key })
      return setFieldValue(field, key)
    }

    return setFieldValueWithState
  }

  const [activeKey, setActiveKey] = useState(id ? 0 : 1)

  function renderForm({ values, errors, handleBlur, setFieldValue, submitForm }) {
    const documentTypeMask = getDocumentMask(values.documentTypeId)
    const setFieldValueWithState = onChange(setFieldValue)

    const hasAccessLocationList = validRule(RULES.CUSTOMER_LOCATION) // Remove a tab de location
    const hasAccessContactList = validRule(RULES.CUSTOMER_CONTACT) // Remove a tab de contact
    const hasAccessForecastList = validRule(RULES.FORECAST) // Remove a tab de forecast
    const hasAccessCultivarsList = validRule(RULES.CULTIVARS) // Remove a tab de cultivares
    const hasAccessActionPlan = validRule(RULES.ACTIONPLAN)

    return (
      <Form className="login-form form-customer" layout="vertical">
        {renderHeader(submitForm)}
        <div className="card-container">
          <Tabs
            defaultActiveKey={id ? '0' : '1'}
            type="card"
            activeKey={activeKey.toString()}
            onTabClick={(key) => setActiveKey(parseInt(key))}
          >
            {id ? renderTabVision(values) : null}
            {renderTabGeneralData(values, documentTypeMask, errors, handleBlur, setFieldValueWithState)}
            {hasAccessLocationList && renderTabLocations(id)}
            {hasAccessContactList && renderTabAlternatives(id)}
            {hasAccessForecastList && renderTabForecasts(id)}
            {hasAccessCultivarsList && renderTabCultivars(id)}
            {hasAccessCultivarsList && renderTabCultivarsHistory(id)}
            {hasAccessActionPlan && formValues.isEib === true && renderTabActionPlan(id)}
          </Tabs>
          <Modal
            footer={null}
            onCancel={() => setIsModalConfirmVisible(!isModalConfirmVisible)}
            width="40%"
            visible={isModalConfirmVisible}
          >
            <div style={{ textAlign: '-webkit-center', margin: '10%' }}>
              <div>
                {alertError ? <img src={AlertIcon} alt="" /> : <img src={ConfirmIco} alt="" />}
                <Typography
                  className="default-header-title"
                  style={{ color: '#334863', padding: '10px 0px 10px' }}
                  level={3}
                >
                  {sucessModalLabel}
                </Typography>
              </div>
            </div>
          </Modal>
        </div>
      </Form>
    )
  }

  return (
    <Formik
      enableReinitialize={true}
      validationSchema={form.yupValidation}
      initialValues={formValues}
      onSubmit={(values, { setSubmitting, setFieldError, resetForm }) =>
        form.onSubmit(values, setSubmitting, setFieldError, resetForm)
      }
      validateOnChange={false}
      validateOnBlur={false}
    >
      {(formikProps) => {
        injectValidationMethods(formikProps.values, form.yupValidation)
        return renderForm(formikProps)
      }}
    </Formik>
  )
}

export default CreateCustomer
